module.exports = __webpack_public_path__ + "static/media/onespan.6f611a35.jpeg";